import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';

import { getSpecialPageList } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';


class cmsSpecialGuests extends Component {

    constructor(props) {
        super(props);
        var url = new URL(window.location.href);
        var location = url.searchParams.get("location");
        var auth_data = JSON.parse(localStorage.getItem("user_data"));
        this.state = {
              logged: localStorage.getItem("authentication"),
              auth_data: JSON.parse(localStorage.getItem("user_data")),
              location: location ? location : (auth_data.access_location ? auth_data.access_location : 'Bengaluru'),
              pageList: [],
        };

        this.getSpecialPageList();
    }


    componentDidMount() {

      var THIS = this;
      $(document).on('click', '.remove_maili', function () {
        var delete_id = $(this).data("id");
        THIS.setState({
          delete_id: delete_id
        })
      });


    }


    getSpecialPageList = () => {
      const { login_id, role } = this.state.auth_data;
      let ins = JSON.stringify({
        vendor_id: login_id,
        role: role
      });
      getSpecialPageList(ins).then((res) => {
        if (res.status == 1) {
          this.setState({
            pageList: res.data
            
          });
        } else {
          this.setState({
            pageList: [],
          });
        }
      });
    }    

    render() {

        const { pageList } = this.state;

        return (
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">BeWise Special Promoted Pages</h4>
                 
 
                  <div class="float-right"><a href="/cms/news/addnews" class="btn btn-primary btn-sm">Add New</a></div>
                 

                  <div class="table-responsive pt-3">
                     <table id="tablebw">
                      <thead  class="thead-dark">
                        <tr>
                          <th>
                            <strong>S.No</strong>
                          </th>
                           <th>
                            <strong>Page Title</strong>
                          </th>
                          <th>
                            <strong>Date</strong>
                          </th>
                          <th>
                            <strong>By</strong>
                          </th>
                                                 
                          <th>
                            <strong>Status</strong>
                          </th>
                          
                          <th>
                            <strong>Action</strong>
                          </th>
                          
                        </tr>
                      </thead>
                      <tbody>
                      {pageList.map((item, i) => {     
                      
                       return <tr>
                          <td>
                            {i+1}
                          </td>
                          
                          <td>
                           {item.page_title}
                          </td>
                          
                          <td>
                           {item.created_date}
                          </td>
                          <td>
                            {item.created_by}
                          </td>
                           
                          <td dangerouslySetInnerHTML={{__html: item.status}} />
                            
                          <td dangerouslySetInnerHTML={{__html: item.action}} />

                        </tr>

                      })

                      }
                       
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default cmsSpecialGuests;


// WEBPACK FOOTER //
// ./src/components/bewise/cmsSpecialGuests.jsx